<template>
  <component
    :is="tag"
    :href="href"
    :type="href ? undefined : 'button'"
    class="archive__button archive__subscribe-form-button"
    :class="[color, { button: !href, tinted, disabled, pending }]"
    :disabled="!href && disabled ? true : undefined"
    :style="{ '--tint-color': TINT_COLOR }"
  >
    <span
      v-if="pending"
      class="action-button-spinner animate-spin"
      aria-label="Loading"
    />
    <template v-else>
      {{ text }}
    </template>
  </component>
</template>

<script setup lang="ts">
import { computed } from "vue";

declare var TINT_COLOR: string;

const props = defineProps<{
  text: string;
  color?: "yellow" | "blue" | "red";
  pending?: boolean;
  disabled?: boolean;
  href?: string;
}>();

const tag = computed(() => (props.href ? "a" : "button"));
const tinted = computed(() => TINT_COLOR !== "#0069FF");
</script>
